import { Route } from 'react-router-dom';
import { PublicRoute } from '../components/auth/PublicRoute';
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage';
import GuestResetPasswordPage from '../pages/auth/GuestResetPasswordPage';
import LoginPage from '../pages/auth/LoginPage';
import RegisterPage from '../pages/auth/RegisterPage';
import ResetPasswordPage from '../pages/auth/ResetPasswordPage';

export const AuthRoutes = [
  <Route key="login" path="/login" element={
    <PublicRoute>
      <LoginPage />
    </PublicRoute>
  } />,
  <Route key="register" path="/register" element={
    <PublicRoute>
      <RegisterPage />
    </PublicRoute>
  } />,
  <Route key="forgot-password" path="/forgot-password" element={
    <PublicRoute>
      <ForgotPasswordPage />
    </PublicRoute>
  } />,
  <Route key="reset-password" path="/reset-password" element={
    <PublicRoute>
      <ResetPasswordPage />
    </PublicRoute>
  } />,
  <Route key="guest-reset-password" path="/guest-reset-password" element={
    <PublicRoute>
      <GuestResetPasswordPage />
    </PublicRoute>
  } />
]; 